import React, { useState, useEffect } from "react";
import { instance2 } from "../../utils/axiosInstance";

export default function EditModal({ data, onClose }) {
  const [formData, setFormData] = useState({
    category_id: data.category_id || "",
    name: data.ingredient_name || "",
    uoq_id: data.uoq_id || "",
    multiple_qty: data.multiple_qty || "",
    frequency_id: data.frequency_id || "",
    buffer: data.buffer || "",
    description: data.description || "",
  });

  const [categories, setCategories] = useState([]); // Options for Kategori Bahan
  const [units, setUnits] = useState([]); // Options for Satuan Berat
  const [frequencies, setFrequencies] = useState([]); // Options for Frekuensi Pengiriman
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state

  const [isFormChanged, setIsFormChanged] = useState(false); // Track form changes

  // Check for form changes
  useEffect(() => {
    const isChanged = JSON.stringify(formData) !== JSON.stringify({
      category_id: data.category_id || "",
      name: data.ingredient_name || "",
      uoq_id: data.uoq_id || "",
      multiple_qty: data.multiple_qty || "",
      frequency_id: data.frequency_id || "",
      buffer: data.buffer || "",
      description: data.description || "",
    });
    setIsFormChanged(isChanged);
  }, [formData, data]);

  // Fetch dropdown options
  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const [categoriesRes, unitsRes, frequenciesRes] = await Promise.all([
          instance2.get("ingredient_category_master"), // Kategori Bahan
          instance2.get("ingredient_uoq_master"), // Satuan Berat
          instance2.get("frequency_master"), // Frekuensi Pengiriman
        ]);

        setCategories(categoriesRes.data);
        setUnits(unitsRes.data);
        setFrequencies(frequenciesRes.data);
      } catch (err) {
        console.error("Error fetching dropdown options:", err);
        setError("Failed to load dropdown options.");
      } finally {
        setLoading(false);
      }
    };

    fetchOptions();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await instance2.put(`ingredient_master/${data.id}`, formData); // Update API call
      //alert("Data updated successfully!");
      onClose();
    } catch (error) {
      console.error("Error updating data:", error);
      alert("Failed to update data.");
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-0 ">
      <div className="bg-white p-6 rounded-lg w-[400px] max-h-[70vh] sm:max-h-[90vh] overflow-auto z-1000 z-50">
        <h2 className="text-lg font-bold mb-4">Ubah Data</h2>
        <form onSubmit={handleSubmit}>
          {/* Kategori Bahan */}
          <div className="mb-4 text-xxs md:text-xxs lg:text-base">
            <label className="block text-gray-700 mb-2">Kategori Bahan</label>
            <select
              name="category_id"
              value={formData.category_id}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1 text-xxs md:text-xxs lg:text-base"
            >
              <option value="" disabled>
                Pilih kategori bahan
              </option>
              {categories.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>
          </div>

          {/* Nama */}
          <div className="mb-4 text-xxs md:text-xxs lg:text-base">
            <label className="block text-gray-700 mb-2">Nama</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1 text-xxs md:text-xxs lg:text-base"
              placeholder="Masukkan nama bahan"
            />
          </div>

          {/* Satuan Berat */}
          <div className="mb-4">
            <label className="block text-gray-700 mb-2 text-xxs md:text-xxs lg:text-base">Satuan Berat</label>
            <select
              name="uoq_id"
              value={formData.uoq_id}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1 text-xxs md:text-xxs lg:text-base"
            >
              <option value="" disabled>
                Pilih unit
              </option>
              {units.map((unit) => (
                <option key={unit.id} value={unit.id}>
                  {unit.name}
                </option>
              ))}
            </select>
          </div>

          {/* Multiple Quantity */}
          <div className="mb-4">
            <label className="block text-gray-700 mb-2 text-xxs md:text-xxs lg:text-base">Multiple Quantity</label>
            <input
              type="number"
              name="multiple_qty"
              value={formData.multiple_qty}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1 text-xxs md:text-xxs lg:text-base"
              placeholder="Masukkan jumlah kelipatan"
            />
          </div>

          {/* Frekuensi Pengiriman */}
          <div className="mb-4">
            <label className="block text-gray-700 mb-2 text-xxs md:text-xxs lg:text-base">Frekuensi Pengiriman</label>
            <select
              name="frequency_id"
              value={formData.frequency_id}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1 text-xxs md:text-xxs lg:text-base"
            >
              <option value="" disabled>
                Pilih frekuensi pengiriman
              </option>
              {frequencies.map((frequency) => (
                <option key={frequency.id} value={frequency.id}>
                  {frequency.name}
                </option>
              ))}
            </select>
          </div>

          {/* Buffer */}
          <div className="mb-4">
            <label className="block text-gray-700 mb-2 text-xxs md:text-xxs lg:text-base">Buffer (%)</label>
            <input
              type="number"
              name="buffer"
              value={formData.buffer}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1 text-xxs md:text-xxs lg:text-base"
              placeholder="Masukkan buffer (%)"
            />
          </div>

          {/* Deskripsi */}
          <div className="mb-4">
            <label className="block text-gray-700 mb-2 text-xxs md:text-xxs lg:text-base">Deskripsi</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1 text-xxs md:text-xxs lg:text-base"
              placeholder="Masukkan deskripsi"
              rows="4"
            />
          </div>

          {/* Actions */}
          <div className="flex justify-end">
            <button
              type="button"
              className="mr-2 px-4 py-2 bg-gray-300 rounded text-xxs md:text-xxs lg:text-base"
              onClick={onClose}
            >
              Batal
            </button>
            <button
              type="submit"
              className={`px-4 py-2 rounded text-xxs md:text-xxs lg:text-base ${
                isFormChanged ? "bg-blue-500 text-white" : "bg-gray-300 text-gray-500 cursor-not-allowed"
              }`}
              disabled={!isFormChanged}
            >
              Simpan
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
